import MenuItem from "./menu-item";

export function AreasColumn({
  areas,
  isMobile,
}: {
  areas: { id: string; name: string; slug: string }[];
  isMobile: boolean;
}) {
  return (
    <div className="grid grid-cols-2 gap-x-[8px] gap-y-[4px] md:gap-[11px]">
      {areas.map((area) => (
        <MenuItem
          key={area.id}
          href={`/areas/${area.slug}`}
          type={isMobile ? "mobileAccordionChild" : "desktopLink"}
        >
          {area.name}
        </MenuItem>
      ))}
    </div>
  );
}
